import React, { useEffect, useState } from "react";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import { useNavigate } from "react-router-dom";
import addmecartLogo from "../assets/addmecart.png";
import { useDispatch, useSelector } from "react-redux";
import { CheckoutApi } from "../redux/slices/CheckoutSlice";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import CryptoJS from "crypto-js";
import LoaderPage from "./Loader";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";

const Checkout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModal, setModal] = useState(false);
  const { ViewCart } = useSelector((state) => state.viewCart);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState(null);
  const [guestDetails, setGuestDetails] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    country: "India",
    streetAddress: "",
    houseNumber: "",
    apartment: "",
    city: "",
    state: "Madhya Pradesh",
    pinCode: "",
    phone: "",
    email: "",
    shippingAddress: false,
    orderNotes: "",
  });

  useEffect(() => {
    dispatch(viewCartData());
  }, [dispatch]);

  const generateSignatureFrontend = (paymentPayload, secretKey) => {
    const sortedValues = Object.entries(paymentPayload)
      .filter(([key, value]) => {
        if (key === "subMerchantPayInfo") return true;
        return value !== null && value !== undefined;
      })
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
      .map(([key, value]) => {
        if (
          key === "subMerchantPayInfo" &&
          (value === null || value === undefined)
        ) {
          return "null";
        }
        return value;
      })
      .join("");

    const stringToHash = sortedValues + secretKey;
    const hash = CryptoJS.SHA256(stringToHash);
    return hash.toString(CryptoJS.enc.Hex);
  };

  const handleGift = () => {
    setLoading(true);
    const storedUuid = localStorage.getItem("uuid");
    axios.post(`${endPoint.ADDONLINEFREEGIFT}`, {
      sessionId: storedUuid,
      paymentMode: "Online"
    })
      .then((res) => {
        setModal(false);
        dispatch(viewCartData());
      })
      .catch((error) => {
        setModal(false);
        console.error("Error adding gift:", error);
        alert("Failed to add gift. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCheckout = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !guestDetails.firstName ||
      !guestDetails.lastName ||
      !guestDetails.streetAddress ||
      !guestDetails.city ||
      !guestDetails.state ||
      !guestDetails.pinCode ||
      !guestDetails.phone ||
      !guestDetails.email
    ) {
      alert("Error: Please fill in all required fields.");
      return;
    }
    else if (!emailRegex.test(guestDetails.email)) {
      alert("Error: Please enter a valid email address.");
      return;
    } else if (selectedPayment == null) {
      alert("Error: Please Select Payment Method");
    } else {
      // if (selectedPayment === "Online") {
      //   setLoading(true);
      //   const billingAddress = {
      //     firstName: guestDetails?.firstName,
      //     lastName: guestDetails?.lastName,
      //     email: guestDetails?.email,
      //     streetAddress: guestDetails?.streetAddress,
      //     city: guestDetails?.city,
      //     state: guestDetails?.state,
      //     pinCode: guestDetails?.pinCode,
      //     phone: guestDetails?.phone,
      //     paymentMethod: selectedPayment,
      //     codAmount: ViewCart?.codCharge,
      //     gatewaySelector: "FreeCharge"
      //   };
      //   const response = await dispatch(CheckoutApi(billingAddress));
      //   const orderId = response?.payload?.orderId;

      //   if (!orderId) {
      //     alert("Order ID not generated");
      //     setLoading(false)
      //     return;
      //   }

      //   const FREECHARGE_MERCHANT_ID = "MER82620b8df7";
      //   const FREECHARGE_CALLBACK_URL = `https://www.addmecart.com/users/verify-payment?orderId=${orderId}`;

      //   const timestamp = Math.floor(Date.now() / 1000);
      //   const merchantTxnId = orderId;
      //   const merchantTxnAmount = (ViewCart?.finalPrice || 0).toFixed(1)
      //   const paymentPayload = {
      //     merchantId: FREECHARGE_MERCHANT_ID,
      //     currency: "INR",
      //     callbackUrl: FREECHARGE_CALLBACK_URL,
      //     timestamp: timestamp,
      //     merchantTxnAmount: merchantTxnAmount,
      //     merchantTxnId: merchantTxnId,
      //   };
      //   const signature = generateSignatureFrontend(
      //     paymentPayload,
      //     "aFor7b+PvWJdFU09wGOODg6dj6h5A7vHsZF8bsVHzXY="
      //   );

      //   paymentPayload.signature = signature;
      //   const checkoutUrl =
      //     "https://secure-axispg.freecharge.in/payment/v1/checkout";
      //   const form = document.createElement("form");
      //   form.method = "POST";
      //   form.action = checkoutUrl;
      //   form.style.display = "none";
      //   form.id = "frmPay";

      //   for (const key in paymentPayload) {
      //     const element = document.createElement("input");
      //     element.value = paymentPayload[key];
      //     element.name = key;
      //     form.appendChild(element);
      //   }
      //   document.body.appendChild(form);
      //   form.submit();
      //   setTimeout(() => {
      //     setLoading(false);
      //   }, 30000)
      // }
      //  else {
      setLoading(true);
      const billingAddress = {
        firstName: guestDetails?.firstName,
        lastName: guestDetails?.lastName,
        email: guestDetails?.email,
        streetAddress: guestDetails?.streetAddress,
        city: guestDetails?.city,
        state: guestDetails?.state,
        pinCode: guestDetails?.pinCode,
        phone: guestDetails?.phone,
        paymentMethod: selectedPayment,
        codAmount: ViewCart?.codCharge,
      };
      dispatch(CheckoutApi(billingAddress))
        .then((response) => {
          setLoading(true);
          if (response.meta.requestStatus === "fulfilled") {
            setLoading(true);
            navigate("/OrderPlace", { state: { data: response } });
          } else {
            console.error("Order failed:", response.payload);
            alert("Failed to place order. Please try again.");
          }
        })
        .catch((error) => {
          setLoading(true);
          console.error("Error placing order:", error);
          alert("Failed to place order. Please try again.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // }
  };

  const _handleDhanKubera = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      !guestDetails.firstName ||
      !guestDetails.lastName ||
      !guestDetails.streetAddress ||
      !guestDetails.city ||
      !guestDetails.state ||
      !guestDetails.pinCode ||
      !guestDetails.phone ||
      !guestDetails.email
    ) {
      alert("Error: Please fill in all required fields.");
      return;
    }
    else if (!emailRegex.test(guestDetails.email)) {
      alert("Error: Please enter a valid email address.");
      return;
    } else if (selectedPayment == null) {
      alert("Error: Please Select Payment Method");
    } else {
      if (selectedPayment === "Online") {
        try {
          setLoading(true);
          const billingAddress = {
            firstName: guestDetails?.firstName,
            lastName: guestDetails?.lastName,
            email: guestDetails?.email,
            streetAddress: guestDetails?.streetAddress,
            city: guestDetails?.city,
            state: guestDetails?.state,
            pinCode: guestDetails?.pinCode,
            phone: guestDetails?.phone,
            paymentMethod: selectedPayment,
            codAmount: ViewCart?.codCharge,
            gatewaySelector: "Dhankubera"
          };
          const response = await dispatch(CheckoutApi(billingAddress));
          const orderId = response?.payload?.orderId;

          if (!orderId) {
            alert("Order ID not generated");
            setLoading(false)
            return;
          }
          setLoading(true);
          const gatewaySelector = "DhanKubera";
          // const merchantTransactionId = response?.data?.merchantTransactionId;
          const DHANKUBERA_CALLBACK_URL = `https://www.addmecart.com/superAdmin/payment/verify-status?txnId=${orderId}`;

          const dhankuberaPayload = {
            "token": "$2y$10$cmqj8nX5UEUl3yvwJpvWMOGmKx51bz2DdHrW51IWYs44r4Odlp2ue",
            "userid": "GWS1155",
            "amount": ViewCart?.finalPrice,
            "mobile": guestDetails?.phone,
            "name": guestDetails?.firstName,
            "orderid": orderId,
            "callback_url": DHANKUBERA_CALLBACK_URL,
            "gatewaySelector": gatewaySelector
          }
          const payinResponse = await axios.post(
            "https://merchant.dhankubera.com/api/pg/urbanpay/initiate",
            dhankuberaPayload,
            {
              headers: { "Content-Type": "application/json" },
            }
          );

          const data = payinResponse.data;
          if (data.status) {
            if (data.qr_code) {
              document.getElementById("qr-image").src = data.qr_code;
            }
            window.location.href = data.url;
          } else {
            alert(`Payment initiation failed: ${data.message}`);
          }
        }
        catch (error) {
          alert("Payment failed. Try again later.");
        } finally {
          setLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    const isCODAvailable = ViewCart?.cart?.every(item => item.isCodeAvailable);
    if (!isCODAvailable) {
      setSelectedPayment("Online");

    }
  }, [ViewCart]);


  const handleOpenModal = () => setModal(true);
  const handleCloseModal = () => setModal(false);

  const handleRemoveGift = async () => {
    const storedUuid = localStorage.getItem("uuid");
    setLoading(true);

    try {
      const response = await axios.delete(`${endPoint.REMOVEFREEGIFT}`, {
        data: { sessionId: storedUuid },
      });

      setModal(false);
      dispatch(viewCartData());
    } catch (error) {
      console.error("Error removing gift:", error);
      alert("Failed to remove gift. Please try again.");
    } finally {
      setLoading(false);
      setModal(false);
    }
  };

  return (
    <div>
      <div className="flex justify-center mb-[-20px]">
        <img src={addmecartLogo} alt="addmecart Logo" className="h-32" />
      </div>
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
        Checkout
      </h1>
      <div className="flex flex-col md:flex-row min-h-screen w-full sm:w-[95%] md:w-[95%] mx-auto p-4 rounded-lg bg-gray-50">
        <div className="h-[20%] w-full md:w-[50%] bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl font-semibold mb-5 text-gray-700">
            Billing Information
          </h2>
          <div className="flex flex-col gap-1">
            <div className="flex gap-5">
              <input
                type="text"
                placeholder="First Name *"
                value={guestDetails.firstName}
                onChange={(e) =>
                  setGuestDetails({
                    ...guestDetails,
                    firstName: e.target.value,
                  })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%] `}
              />
              <input
                type="text"
                placeholder="Last Name *"
                value={guestDetails.lastName}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, lastName: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
            </div>
            <select
              value={guestDetails.country}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, country: e.target.value })
              }
              className={CustomeStyle.inputBox}
            >
              <option value="India">India</option>
            </select>
            <input
              type="text"
              placeholder="Full Address - House no. , Bulding"
              value={guestDetails.streetAddress}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  streetAddress: e.target.value,
                })
              }
              className={CustomeStyle.inputBox}
            />
            <div className="flex gap-5">
              <input
                type="text"
                placeholder="City *"
                value={guestDetails.city}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, city: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
              <input
                type="text"
                placeholder="State *"
                value={guestDetails.state}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, state: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
            </div>
            <input
              type="number"
              placeholder="PIN Code *"
              value={guestDetails.pinCode}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, pinCode: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="tel"
              placeholder="Phone *"
              value={guestDetails.phone}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  phone: e.target.value.replace(/[^0-9]/g, ""),
                })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="email"
              placeholder="Email Address *"
              value={guestDetails.email}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, email: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
          </div>

          <div className="mt-6">
            <label className="text-lg text-gray-600 mb-5 block">
              <input
                type="checkbox"
                checked={guestDetails.shippingAddress}
                onChange={(e) =>
                  setGuestDetails({
                    ...guestDetails,
                    shippingAddress: e.target.checked,
                  })
                }
                className="mr-2"
              />
              Ship to a different address?
            </label>
            <textarea
              placeholder="Order Notes (Optional)"
              value={guestDetails.orderNotes}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, orderNotes: e.target.value })
              }
              className="block w-full p-3 mb-6 text-lg border border-gray-300 rounded-lg bg-gray-50 h-32"
            />
          </div>
        </div>

        <div className="h-full w-[100%] md:w-[50%] bg-white p-5 rounded-lg shadow-sm mt-6 md:mt-0 ml-0 md:ml-8">
          <h2 className="text-2xl font-semibold mb-5">Your Order</h2>

          {ViewCart?.cart &&
            Array.isArray(ViewCart.cart) &&
            ViewCart.cart.length > 0 ? (
            <>
              <div className="flex justify-between  pb-2 mb-1 text-gray-500 font-medium">
                <span className="w-[45%]">Item</span>
                <span>Sale Price</span>
                <span>Qty</span>
                <span>Price</span>
              </div>

              {ViewCart?.cart.map((item, index) => {
                return (
                  <div key={index} className="mb-4">
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700 w-[50%] overflow-hidden line-clamp-3">
                        {item.title}
                      </span>
                      <span className="text-gray-600">{item.salePrice}</span>
                      <span className="text-gray-600">{item.quantity}</span>
                      <span className="font-semibold text-blue-500">
                        ₹{item.finalPrice}
                      </span>
                    </div>

                    {item?.appliedCoupon && (
                      <div className="rounded-lg  border-b  mb-5 pb-5 ">
                        <span className="text-black  text-xs font-semibold">
                          Apply Coupons:
                        </span>
                        <div className=" text-gray-600">
                          <span className="text-xs font-semibold text-black">
                            Discount:{" "}
                          </span>
                          <span className=" text-xs text-black font-semibold ms-2">
                            {item?.appliedCoupon?.discountType == "fixed" &&
                              "₹"}
                            {item?.appliedCoupon?.discountValue}{" "}
                            {item?.appliedCoupon?.discountType == "fixed"
                              ? ""
                              : "%"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-semibold text-black">
                            Discount Price:
                          </span>
                          <span className="text-xs font-semibold text-black">
                            ₹{item?.finalPrice}
                          </span>
                          <span className="text-xs line-through text-gray-500">
                            ₹{item?.totalBeforeCoupon}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          ) : (
            <p>No items in the cart.</p>
          )}

          {/* ---------------------------------Order Data -------------------------------- */}
          <div className="flex justify-between font-semibold mt-1 text-gray-600">
            <span>Shipping Charges</span>
            <span className="text-black font-semibold">
              ₹ {ViewCart?.shippingCost}
            </span>
          </div>
          <div className="flex justify-between font-semibold text-xl  border-gray-200">
            <span>Total</span>
            <span>₹{ViewCart?.finalPrice?.toFixed(2)}</span>
          </div>

          <div className="mx-auto p-6 bg-white shadow-lg rounded-lg border mt-4 border-gray-100">
            <div className="mb-6">
              <h3 className="font-semibold text-lg mb-2">Pay Securely</h3>
            </div>

            {/* <section className="mt-4">
              <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                <label
                  className="flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer"
                  onClick={() => {
                    setSelectedPayment("Online");
                    handleGift();
                  }}
                >
                  <input
                    type="radio"
                    name="payment"
                    className="w-4 h-4 text-green-600 focus:ring-green-500"
                    checked={selectedPayment === "Online"}
                    readOnly
                  />
                  <span className="text-lg text-gray-700">
                    Pay securely by Credit Card/ Debit Card/ UPI or Internet Banking
                  </span>
                </label>
              </div>
            </section>

            {
              ViewCart?.cart?.length > 0 &&
              ViewCart?.cart
                ?.filter(item => !item?.associatedWithMainProduct)?.every(item => item?.isCodeAvailable) && (
                <section className="mt-4">
                  <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                    <label
                      className="flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer"
                      onClick={() => {
                        setSelectedPayment("COD");

                      }}
                    >
                      <input
                        type="radio"
                        name="payment"
                        className="w-4 h-4 text-green-600 focus:ring-green-500"
                        checked={selectedPayment === "COD"}
                        readOnly
                      />
                      <span className="text-lg text-gray-700">
                        Cash On Delivery
                      </span>
                    </label>
                  </div>
                  {selectedPayment === "COD" &&
                    <>
                      <div className="sm:flex  mt-2 text-sm font-bold border-gray-200 justify-center sm:justify-between">
                        <div>
                          <span>COD Charge :- </span>
                          <span>₹100</span>
                        </div>
                        <span className="text-black ">Updated Order Price :- <span className="text-blue-500">{(ViewCart?.finalPrice + 100).toFixed(2)}</span></span>
                      </div>
                      <span className="text-sm text-black font-bold">Avoid ₹100 COD Charges. Paying Online</span>
                    </>
                  }
                </section>
              )} */}
            <section className="mt-4">
              {/* <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                <label
                  className={`flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer ${selectedGateway === "Standard" ? "border-green-600" : ""
                    }`}
                  onClick={() => {
                    setSelectedPayment("Online");
                    setSelectedGateway("Standard");
                    handleGift();
                  }}
                >
                  <input
                    type="radio"
                    name="payment"
                    className="w-4 h-4 text-green-600 focus:ring-green-500"
                    checked={selectedPayment === "Online" && selectedGateway === "Standard"}
                    readOnly
                  />
                  <span className="text-lg text-gray-700">
                    Pay securely by Credit Card / Debit Card / UPI / Internet Banking
                  </span>
                </label>
              </div> */}

              <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                <label
                  className={`flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer ${selectedGateway === "DhanKubera" ? "border-green-600" : ""
                    }`}
                  onClick={() => {
                    setSelectedPayment("Online");
                    setSelectedGateway("DhanKubera");
                    handleGift();
                  }}
                >
                  <input
                    type="radio"
                    name="payment"
                    className="w-4 h-4 text-green-600 focus:ring-green-500"
                    checked={selectedPayment === "Online" && selectedGateway === "DhanKubera"}
                    readOnly
                  />
                  <span className="text-lg text-gray-700">Pay with DhanKubera Credit Card / Debit Card / UPI / Internet Banking</span>
                </label>
              </div>
            </section>

            {ViewCart?.cart?.length > 0 &&
              ViewCart?.cart
                ?.filter((item) => !item?.associatedWithMainProduct)
                ?.every((item) => item?.isCodeAvailable) && (
                <section className="mt-4">
                  <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                    <label
                      className={`flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer ${selectedPayment === "COD" ? "border-green-600" : ""
                        }`}
                      onClick={() => {
                        setSelectedPayment("COD");
                        setSelectedGateway(null);
                      }}
                    >
                      <input
                        type="radio"
                        name="payment"
                        className="w-4 h-4 text-green-600 focus:ring-green-500"
                        checked={selectedPayment === "COD"}
                        readOnly
                      />
                      <span className="text-lg text-gray-700">Cash On Delivery</span>
                    </label>
                  </div>

                  {selectedPayment === "COD" && (
                    <>
                      <div className="sm:flex mt-2 text-sm font-bold border-gray-200 justify-center sm:justify-between">
                        <div>
                          <span>COD Charge :- </span>
                          <span>₹100</span>
                        </div>
                        <span className="text-black">
                          Updated Order Price :-{" "}
                          <span className="text-blue-500">
                            {(ViewCart?.finalPrice + 100).toFixed(2)}
                          </span>
                        </span>
                      </div>
                      <span className="text-sm text-black font-bold">
                        Avoid ₹100 COD Charges by Paying Online
                      </span>
                    </>
                  )}
                </section>
              )}

            <section className="mt-4 mb-2">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input type="checkbox" className="h-4 w-4 text-green-600" />
                <span className="text-sm">
                  I agree to the{" "}
                  <a href="/terms-of-service" className="text-blue-600 underline">
                    Terms and Conditions
                  </a>
                </span>
              </label>
            </section>
          </div>
          {/* <button
            onClick={() => {
              const hasFreeGift = ViewCart?.cart?.some(item => item?.isFreeGift === true);
              if (hasFreeGift) {
                if (selectedPayment === "COD") {
                  handleOpenModal();
                }
              }
              if (selectedPayment === "Online") {
                if (selectedGateway === "Standard") {
                  handleCheckout();
                }
                else if (selectedGateway === "DhanKubera") {
                  _handleDhanKubera();
                }
                else {
                  alert("Please select a payment gateway before confirming your order.");
                }
              }
              else {
                alert("Please select a payment method before confirming your order.");
              }
            }}
            
            disabled={loading}
            className="mt-4 w-full py-3 text-xl bg-orange-400 text-white rounded-lg hover:bg-orange-700 transition duration-300"
          >
            {loading ? "PROCESSING..." : "Confirm Order"}
          </button> */}

          <button
            onClick={() => {
              const hasFreeGift = ViewCart?.cart?.some(item => item?.isFreeGift === true);

              if (hasFreeGift) {
                if (selectedPayment === "COD") {
                  handleOpenModal();
                }
                else if (selectedPayment === "Online") {
                  if (selectedGateway === "Standard") {
                    handleCheckout();
                  }
                  else if (selectedGateway === "DhanKubera") {
                    _handleDhanKubera();
                  }
                  else {
                    alert("Please select a payment gateway before confirming your order.");
                  }
                }
                else {
                  alert("Please select a payment method before confirming your order.");
                }
              }
              else {
                if (selectedPayment === "COD") {
                  handleCheckout();
                }
                else if (selectedPayment === "Online") {
                  // if (selectedGateway === "Standard") {
                  //   handleCheckout();
                  // }
                  // else
                  if (selectedGateway === "DhanKubera") {
                    _handleDhanKubera();
                  }
                  else {
                    alert("Please select a payment gateway before confirming your order.");
                  }
                }
                else {
                  alert("Please select a payment method before confirming your order.");
                }
              }
            }}
            disabled={loading}
            className={`mt-4 w-full py-3 text-xl rounded-lg transition duration-300 ${loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-orange-400 text-white hover:bg-orange-700"
              }`}
          >
            {loading ? "PROCESSING..." : "Confirm Order"}
          </button>

        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 text-center">
            <p className="text-gray-700 text-lg mb-6">
              Remove Free Gift to Continue With COD
            </p>

            <div className="flex justify-between gap-4">
              <button
                onClick={handleCloseModal}
                className="w-1/2 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleRemoveGift}
                className="w-1/2 bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-md"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <LoaderPage />}
      <Footer />
    </div>
  );
};

export default Checkout;
